import type { FaireProductEntity } from "../../entity_types/product";

export const p_u7mswf2r75: FaireProductEntity = {
  token: "p_u7mswf2r75",
  type: "product",
  name: "Chocolate Coconut Fudge with Shredded Coconut",
  brandToken: "b_hxncymjum6",
  brandName: "Phenomenal Fudge",
  imageUrl:
    "https://cdn.faire.com/fastly/e6929584006852a5fbcf0e2d865336a5afc6b9fda856af9831f41dc77a0a279b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/17488c40f6f10fe43e4d2599dec167d069c457a805e2b00051a0cbb372e818f0.jpeg",
  ],
  priceDollars: 7.58,
  description:
    "Our Chocolate Coconut fudge is made with shredded coconut and is a classic flavor in our line-up. The sweetened coconut is mixed throughout our regular chocolate fudge. You won’t have to hunt for the coconut. It’s everywhere! FREE SHIPPING on all orders over $55. \n\nChocolate Coconut fudge is often a popular selection in many of our Fudge Club gift packages. \n\nChocolate Coconut in a 1/2 pound resealable tub.\n",
  tags: [],
  msrpDollars: 15.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:13.409Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
